function storePickup() {
  const pickupTab = document.querySelector('.delivery-pickup-tab--pickup');
  if (!pickupTab) {
    return;
  }

  const productHandle = pickupTab.getAttribute('data-product-handle');
  const productType = pickupTab.getAttribute('data-product-type');
  if (!productHandle) {
    return;
  }

  const productId = pickupTab.getAttribute('data-product-id');
  if (!productId) {
    return;
  }

  const preorder = pickupTab.getAttribute('data-preorder');
  if (preorder === true || preorder === 'true') {
    return;
  }

  fetch(`https://api.gamo-hub.com.au/api/shopify-listing/product/inventory/get/${productId}`, {
    method: 'GET',
    headers: {
      'Content-Type': 'application/json',
    },
  })
  .then((response) => {
    if (!response.ok) {
      throw new Error(`API returned status: ${response.status}`);
    }
    return response.json();
  })
  .then((data) => {
    if (!data || !data[0] || !data[0].inventory) {
      console.warn(`Invalid inventory data format received`);
      return;
    }

    const inventories = data[0].inventory;

    const claytonPickupAvailabilityElement = document.querySelector('.delivery-pickup-tab__content-body__store-instore-description.pickup-clayton');
    const brunswickPickupAvailabilityElement = document.querySelector('.delivery-pickup-tab__content-body__store-instore-description.pickup-brunswick');
    const boxhillPickupAvailabilityElement = document.querySelector('.delivery-pickup-tab__content-body__store-instore-description.pickup-boxhill');
    let claytonPickupInStock = false;
    let brunswickPickupInStock = false;
    let boxhillPickupInStock = false;

    const claytonRetailAvailabilityElement = document.querySelector('.delivery-pickup-tab__content-body__store-instore-description.buyinstore-clayton');
    const brunswickRetailAvailabilityElement = document.querySelector('.delivery-pickup-tab__content-body__store-instore-description.buyinstore-brunswick');
    const boxhillRetailAvailabilityElement = document.querySelector('.delivery-pickup-tab__content-body__store-instore-description.buyinstore-boxhill');
    let claytonRetailInStock = false;
    let brunswickRetailInStock = false;
    let boxhillRetailInStock = false;

    let claytonPickupStock = 0;
    let brunswickPickupStock = 0;
    let boxhillPickupStock = 0;
    let claytonBuyinstoreStock = 0;
    let brunswickBuyinstoreStock = 0;
    let boxhillBuyinstoreStock = 0;

    let claytonStock = 0;
    let claytonRetailStock = 0;
    let brunswickRetailStock = 0;
    let boxhillRetailStock = 0;

    inventories.forEach((inv) => {
      if (inv.location.toLowerCase() == 'gameology warehouse') {
        claytonStock += inv.stock;
      }

      if (inv.location.toLowerCase() == 'clayton retail store') {
        claytonRetailStock += inv.stock;
      }

      if (inv.location.toLowerCase() == 'brunswick retail store') {
        brunswickRetailStock += inv.stock;
      }

      if (inv.location.toLowerCase() == 'box hill retail store') {
        boxhillRetailStock += inv.stock;
      }
    });

    console.log('MRMR claytonStock', claytonStock);
    console.log('MRMR claytonRetailStock', claytonRetailStock);
    console.log('MRMR brunswickRetailStock', brunswickRetailStock);
    console.log('MRMR boxhillRetailStock', boxhillRetailStock);

    claytonPickupStock = claytonStock + claytonRetailStock;
    brunswickPickupStock = claytonStock + brunswickRetailStock;
    boxhillPickupStock = claytonStock + boxhillRetailStock;
    if(productType == 'Single Cards' || productType == 'Graded Cards'){
      claytonBuyinstoreStock = claytonRetailStock;
    }
    else {
      claytonBuyinstoreStock = claytonStock + claytonRetailStock;
    }
    brunswickBuyinstoreStock = brunswickRetailStock;
    boxhillBuyinstoreStock = boxhillRetailStock;

    console.log('MRMR claytonPickupStock', claytonPickupStock);
    console.log('MRMR brunswickPickupStock', brunswickPickupStock);
    console.log('MRMR boxhillPickupStock', boxhillPickupStock);
    console.log('MRMR claytonBuyinstoreStock', claytonBuyinstoreStock);
    console.log('MRMR brunswickBuyinstoreStock', brunswickBuyinstoreStock);
    console.log('MRMR boxhillBuyinstoreStock', boxhillBuyinstoreStock);

    if (claytonPickupAvailabilityElement) {
      if (claytonPickupStock <= 0) {
        claytonPickupAvailabilityElement.textContent = 'OUT OF STOCK';
        claytonPickupAvailabilityElement.classList.add('unavailable');
        claytonPickupAvailabilityElement.classList.remove('available');
        claytonPickupAvailabilityElement.classList.remove('limited');
        claytonPickupInStock = false;
      } else if (claytonPickupStock > 0 && claytonPickupStock <= 10) {
        claytonPickupAvailabilityElement.textContent = `${claytonPickupStock} AVAILABLE`;
        claytonPickupAvailabilityElement.classList.add('available');
        claytonPickupAvailabilityElement.classList.remove('unavailable');
        claytonPickupAvailabilityElement.classList.remove('limited');
        claytonPickupInStock = true;
      } else {
        claytonPickupAvailabilityElement.textContent = 'AVAILABLE';
        claytonPickupAvailabilityElement.classList.add('available');
        claytonPickupAvailabilityElement.classList.remove('unavailable');
        claytonPickupAvailabilityElement.classList.remove('limited');
        claytonPickupInStock = true;
      }
    }

    if(claytonStock == 0 && (claytonRetailStock > 0 || brunswickRetailStock > 0 || boxhillRetailStock > 0)){
      if(document.querySelector('.delivery-pickup-tab__content.show .inStockShow') != null){
        document.querySelector('.delivery-pickup-tab__content.show .inStockShow').classList.add('hidden');
        document.querySelector('.delivery-pickup-tab__content-bottom.inStockShow').classList.add('hidden');
        document.querySelector('.delivery-pickup-tab__content.show .inStockPickupOnly').classList.remove('hidden');
      }
    }

    if (brunswickPickupAvailabilityElement) {
      if (brunswickPickupStock <= 0) {
        brunswickPickupAvailabilityElement.textContent = 'OUT OF STOCK';
        brunswickPickupAvailabilityElement.classList.add('unavailable');
        brunswickPickupAvailabilityElement.classList.remove('available');
        brunswickPickupAvailabilityElement.classList.remove('limited');
        brunswickPickupInStock = false;
      } else if (brunswickPickupStock > 0 && brunswickPickupStock <= 10) {
        brunswickPickupAvailabilityElement.textContent = `${brunswickPickupStock} AVAILABLE`;
        brunswickPickupAvailabilityElement.classList.add('available');
        brunswickPickupAvailabilityElement.classList.remove('unavailable');
        brunswickPickupAvailabilityElement.classList.remove('limited');
        brunswickPickupInStock = true;
      } else {
        brunswickPickupAvailabilityElement.textContent = 'AVAILABLE';
        brunswickPickupAvailabilityElement.classList.add('available');
        brunswickPickupAvailabilityElement.classList.remove('unavailable');
        brunswickPickupAvailabilityElement.classList.remove('limited');
        brunswickPickupInStock = true;
      }
    }
    if (boxhillPickupAvailabilityElement) {
      if (boxhillPickupStock <= 0) {
        boxhillPickupAvailabilityElement.textContent = 'OUT OF STOCK';
        boxhillPickupAvailabilityElement.classList.add('unavailable');
        boxhillPickupAvailabilityElement.classList.remove('available');
        boxhillPickupAvailabilityElement.classList.remove('limited');
        boxhillPickupInStock = false;
      } else if (boxhillPickupStock > 0 && boxhillPickupStock <= 10) {
        boxhillPickupAvailabilityElement.textContent = `${boxhillPickupStock} AVAILABLE`;
        boxhillPickupAvailabilityElement.classList.add('available');
        boxhillPickupAvailabilityElement.classList.remove('unavailable');
        boxhillPickupAvailabilityElement.classList.remove('limited');
        boxhillPickupInStock = true;
      } else {
        boxhillPickupAvailabilityElement.textContent = 'AVAILABLE';
        boxhillPickupAvailabilityElement.classList.add('available');
        boxhillPickupAvailabilityElement.classList.remove('unavailable');
        boxhillPickupAvailabilityElement.classList.remove('limited');
        boxhillPickupInStock = true;
      }
    }

    if (claytonRetailAvailabilityElement) {
      if (claytonBuyinstoreStock <= 0) {
        claytonRetailAvailabilityElement.textContent = 'OUT OF STOCK';
        claytonRetailAvailabilityElement.classList.add('unavailable');
        claytonRetailAvailabilityElement.classList.remove('available');
        claytonRetailAvailabilityElement.classList.remove('limited');
        claytonRetailInStock = false;
      } else if (claytonBuyinstoreStock > 0 && claytonBuyinstoreStock <= 10) {
        claytonRetailAvailabilityElement.textContent = `${claytonBuyinstoreStock} AVAILABLE`;
        claytonRetailAvailabilityElement.classList.add('available');
        claytonRetailAvailabilityElement.classList.remove('unavailable');
        claytonRetailAvailabilityElement.classList.remove('limited');
        claytonRetailInStock = true;
      } else {
        claytonRetailAvailabilityElement.textContent = '10+ AVAILABLE';
        claytonRetailAvailabilityElement.classList.add('available');
        claytonRetailAvailabilityElement.classList.remove('unavailable');
        claytonRetailAvailabilityElement.classList.remove('limited');
        claytonRetailInStock = true;
      }
    }

    if (brunswickRetailAvailabilityElement) {
      if (brunswickBuyinstoreStock <= 0) {
        brunswickRetailAvailabilityElement.textContent = 'OUT OF STOCK';
        brunswickRetailAvailabilityElement.classList.add('unavailable');
        brunswickRetailAvailabilityElement.classList.remove('available');
        brunswickRetailAvailabilityElement.classList.remove('limited');
        brunswickRetailInStock = false;
      } else if (brunswickBuyinstoreStock > 0 && brunswickBuyinstoreStock <= 10) {
        brunswickRetailAvailabilityElement.textContent = `${brunswickBuyinstoreStock} AVAILABLE`;
        brunswickRetailAvailabilityElement.classList.add('available');
        brunswickRetailAvailabilityElement.classList.remove('unavailable');
        brunswickRetailAvailabilityElement.classList.remove('limited');
        brunswickRetailInStock = true;
      } else {
        brunswickRetailAvailabilityElement.textContent = '10+ AVAILABLE';
        brunswickRetailAvailabilityElement.classList.add('available');
        brunswickRetailAvailabilityElement.classList.remove('unavailable');
        brunswickRetailAvailabilityElement.classList.remove('limited');
        brunswickRetailInStock = true;
      }
    }

    if (boxhillRetailAvailabilityElement) {
      if (boxhillBuyinstoreStock <= 0) {
        boxhillRetailAvailabilityElement.textContent = 'OUT OF STOCK';
        boxhillRetailAvailabilityElement.classList.add('unavailable');
        boxhillRetailAvailabilityElement.classList.remove('available');
        boxhillRetailAvailabilityElement.classList.remove('limited');
        boxhillRetailInStock = false;
      } else if (boxhillBuyinstoreStock > 0 && boxhillBuyinstoreStock <= 10) {
        boxhillRetailAvailabilityElement.textContent = `${boxhillBuyinstoreStock} AVAILABLE`;
        boxhillRetailAvailabilityElement.classList.add('available');
        boxhillRetailAvailabilityElement.classList.remove('unavailable');
        boxhillRetailAvailabilityElement.classList.remove('limited');
        boxhillRetailInStock = true;
      } else {
        boxhillRetailAvailabilityElement.textContent = '10+ AVAILABLE';
        boxhillRetailAvailabilityElement.classList.add('available');
        boxhillRetailAvailabilityElement.classList.remove('unavailable');
        boxhillRetailAvailabilityElement.classList.remove('limited');
        boxhillRetailInStock = true;
      }
    }

    const deliveryAvailabilityText = document.querySelector('.delivery-pickup-tab--delivery .delivery-pickup-tab__header-availability-text');
    if (deliveryAvailabilityText) {
      if (claytonStock <= 5 && claytonStock > 0) {
        deliveryAvailabilityText.textContent = 'LIMITED STOCK';
        deliveryAvailabilityText.classList.add('limited');
        deliveryAvailabilityText.classList.remove('unavailable');
        deliveryAvailabilityText.classList.remove('available');
      } else if (claytonStock > 5) {
        deliveryAvailabilityText.textContent = 'AVAILABLE';
        deliveryAvailabilityText.classList.add('available');
        deliveryAvailabilityText.classList.remove('unavailable');
        deliveryAvailabilityText.classList.remove('limited');
      } else {
        deliveryAvailabilityText.textContent = 'OUT OF STOCK';
        deliveryAvailabilityText.classList.add('unavailable');
        deliveryAvailabilityText.classList.remove('limited');
        deliveryAvailabilityText.classList.remove('available');
      }
    }

    const deliveryPickupOnlyAvailabilityText = document.querySelector('.delivery-pickup-tab--delivery .delivery-pickup-tab__header-availability-text.pickuponly');
    if(deliveryPickupOnlyAvailabilityText){
      deliveryPickupOnlyAvailabilityText.textContent = 'NOT AVAILABLE';
    }

    const pickupAvailabilityText = document.querySelector('.delivery-pickup-tab--pickup .delivery-pickup-tab__header-availability-text');
    if (pickupAvailabilityText) {
      if (claytonPickupInStock === true && brunswickPickupInStock === true && boxhillPickupInStock === true && claytonPickupStock > 5 && bruswickPickupStock > 5 && boxhillPickupStock > 5) {
        pickupAvailabilityText.textContent = 'AVAILABLE';
        pickupAvailabilityText.classList.add('available');
        pickupAvailabilityText.classList.remove('unavailable');
        pickupAvailabilityText.classList.remove('limited');
      } else if (claytonPickupInStock === false && brunswickPickupInStock === false && boxhillPickupInStock === false && claytonPickupStock == 0 && bruswickPickupStock == 0 && boxhillPickupStock == 0) {
        pickupAvailabilityText.textContent = 'OUT OF STOCK';
        pickupAvailabilityText.classList.add('unavailable');
        pickupAvailabilityText.classList.remove('limited');
        pickupAvailabilityText.classList.remove('available');
      } else {
        pickupAvailabilityText.textContent = 'LIMITED STOCK';
        pickupAvailabilityText.classList.add('limited');
        pickupAvailabilityText.classList.remove('unavailable');
        pickupAvailabilityText.classList.remove('available');
      }
    }

    const buyInStoreAvailabilityText = document.querySelector('.delivery-pickup-tab--buyinstore .delivery-pickup-tab__header-availability-text');
    if (buyInStoreAvailabilityText) {
      if (claytonRetailInStock === true && brunswickRetailInStock === true && boxhillRetailInStock === true) {
        buyInStoreAvailabilityText.textContent = 'AVAILABLE';
        buyInStoreAvailabilityText.classList.add('available');
        buyInStoreAvailabilityText.classList.remove('unavailable');
        buyInStoreAvailabilityText.classList.remove('limited');
      } else if (claytonRetailInStock === false && brunswickRetailInStock === false && boxhillRetailInStock === false) {
        buyInStoreAvailabilityText.textContent = 'OUT OF STOCK';
        buyInStoreAvailabilityText.classList.add('unavailable');
        buyInStoreAvailabilityText.classList.remove('limited');
        buyInStoreAvailabilityText.classList.remove('available');
      } else {
        buyInStoreAvailabilityText.textContent = 'LIMITED STOCK';
        buyInStoreAvailabilityText.classList.add('limited');
        buyInStoreAvailabilityText.classList.remove('unavailable');
        buyInStoreAvailabilityText.classList.remove('available');
      }
    }
  })
  .catch((error) => {
    console.error('Error fetching inventory data:', error);
  });
}

document.addEventListener('DOMContentLoaded', function() {
  storePickup();
});
